import { REHYDRATE } from 'redux-persist/constants';
import _transform from 'lodash/transform';
import _sortBy from 'lodash/sortBy';
import APPCONFIG from '../../constants/Config';
import countryList from '../../constants/Country';
import {
  UPDATE_PERSIST_STORE_VERSION,
  CHANGE_LOCALE,
  GET_OPERATORS_SUCCESS,
} from '../../constants/ActionTypes';
// Custom
import localesManager from '../../intl/LocalesManager';
import { getCountriesNames } from '../../utils/Tools';

const buildAll = (language) => _sortBy(
  _transform(getCountriesNames(language), (result, value, key) => {
    result.push({
      code: key, label: value,
    });
  }, []), ['label'],
);

const initialSettings = APPCONFIG.country;
const country = (state = initialSettings, action) => {
  switch (action.type) {
    case UPDATE_PERSIST_STORE_VERSION:
      return {
        ...state,
        all: buildAll(APPCONFIG.intl.language),
      };
    case REHYDRATE:
      return {
        ...state,
        all: buildAll(action.payload.intl.language),
        known: countryList,
      };
    case CHANGE_LOCALE:
      return {
        ...state,
        all: buildAll(localesManager.getLocale(action.locale).language),
      };
    case GET_OPERATORS_SUCCESS:
      return {
        ...state,
        known: countryList,
      };
    default:
      return state;
  }
};

export default country;



// WEBPACK FOOTER //
// ./reducers/app/country.js